import { ReactNode } from 'react';
import { CoreBox, CoreTooltip, CoreTypography } from '@youscience/core';

import { Container } from '@components/Layout/components/Container';

import { STATES } from '@constants/scholarshipDetail';

import InfoIcon from '@images/info.svg?react';
import StateIcon from '@images/ScholarshipsIcons/place.svg?react';

import { sxStyles, StyledStatesWrap } from './Locations.styles';

const renderStateItem = (icon: ReactNode, fieldName: string) => {
  return (
    <CoreBox key={fieldName} sx={sxStyles.stateItem}>
      {icon}

      <CoreTypography>{fieldName}</CoreTypography>
    </CoreBox>
  );
};

interface LocationsProps {
  stateResidence: string[];
  stateRestrictions: string[];
}

export const Locations = (props: LocationsProps) => {
  const { stateRestrictions, stateResidence } = props;

  if (!stateResidence?.length && !stateRestrictions?.length) return null;

  return (
    <Container sx={sxStyles.container}>
      <CoreTypography sx={sxStyles.sectionTitle} variant="h3" component="h2">
        Locations
      </CoreTypography>

      {stateResidence?.length > 0 && (
        <CoreBox>
          <CoreBox sx={sxStyles.sectionItemTitle}>
            <CoreTypography variant="overline" component="h5">
              State residence
            </CoreTypography>

            <CoreTooltip title="State residence refers to the award restrictions on the applicant's state or provincial residence.">
              <CoreBox sx={sxStyles.tooltipIcon}>
                <InfoIcon />
              </CoreBox>
            </CoreTooltip>
          </CoreBox>

          <StyledStatesWrap>
            {stateResidence?.map((state) => renderStateItem(<StateIcon />, STATES[state]))}
          </StyledStatesWrap>
        </CoreBox>
      )}

      {stateRestrictions?.length > 0 && (
        <CoreBox>
          <CoreBox sx={sxStyles.sectionItemTitle}>
            <CoreTypography variant="overline" component="h5">
              Use in states
            </CoreTypography>

            <CoreTooltip title="Use in states refers to the award restrictions for study in certain state(s) or province(s).">
              <CoreBox sx={sxStyles.tooltipIcon}>
                <InfoIcon />
              </CoreBox>
            </CoreTooltip>
          </CoreBox>

          <StyledStatesWrap>
            {stateRestrictions?.map((state) => renderStateItem(<StateIcon />, STATES[state]))}
          </StyledStatesWrap>
        </CoreBox>
      )}
    </Container>
  );
};
